import st from './index.scss'
import React, { useEffect, useState } from 'react'
import { Icon } from '@/components';
import { observer } from '@/hooks/storeHooks'
import cn from 'classnames'
import { useScroll } from 'ahooks'
import { Link } from '@/components'
import { useType } from '@/hooks'
import { useNavigate } from 'react-router-dom'
import Guide from './guide';

export default observer(function FixBarRight({ scrollRef }) {

    const type  = useType()
    let [showScrollTop, setShowScrollTop] = useState(false)
    // const scroll = useScroll(scrollRef)
    const scroll = useScroll(document);

    useEffect(() => {
        // if (scroll?.top > 100) {
        //     setShowScrollTop(true)
        // } else {
        //     setShowScrollTop(false)
        // }
        const top = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        setShowScrollTop(scroll?.top > top)
    }, [scroll])

    const goTop = ()=> {
        document.body.scrollIntoView({
            behavior: "smooth",
        });
    }

    const navigate = useNavigate()
    const handleClick = (item)=> {
        if(item.onClick) {
            item.onClick()
        }else if(item.path) {
            navigate(`/${type}${item.path}`)
        }
    }

    const fixBar = [
        {
            name: '新人优惠',
            icon: 'youce-youhui',
            path: `/activity/2023-new-user`,
        },
        {
            name: '商城',
            icon: 'youce-shangcheng',
            list: [
                {name: '图书', path: `/book`},
                {name: '公开课', path: `/open`},
                {name: '面授', path: '/mianshou'},
                {name: '网授', path: '/wangshou'},
            ],
            className: 'shop'
        },
        {
            name: '关于我们',
            icon: 'youce-guanyuwomen',
            list: [
                {name: '众合在线App', src: 'https://oss.zhumavip.com/activity/zhonline/zhongheqr.png'},
                {name: '竹马App', src: 'https://osscdn2.zhongheschool.com/common/defaultType/202312/202312111131480374.png'},
                {name: '微博', src: 'https://osscdn2.zhongheschool.com/common/defaultType/202312/202312061903310529.png'},
                {name: '微信公众号', src: 'https://osscdn2.zhongheschool.com/common/defaultType/202312/202312061903310271.png'},
            ],
            className: 'about'
        },
        {
            name: '客服',
            icon: 'youce-kefu',
            onClick: ()=> {
                window._MEIQIA('showPanel')
            },
        },
    ]

    return (
        <>
            <Guide />
            <div className={st['fix-bar']}>
                {/* <div className={st['fix-bar-top']}>
                    <Link to={`/${type}/activity/2023-new-user`}>
                        <img src="https://crmoss.zhongheschool.com/wzb-crm/images/1678628266267.gif" />
                    </Link>
                </div> */}
                <div className={st['fix-bar-top']}>
                    <Link to={`/${type}/activity/2024-new-user`}>
                        <img src="https://osscdn2.zhongheschool.com/common/defaultType/202403/202403212149150074.gif" alt=""/>
                    </Link>
                </div>
                <div className={cn(st['fix-bar-right-box'], {
                    [st['active']]: showScrollTop
                })} id="guide_fixbar">
                    {fixBar.map((item, index) => {
                        return (
                            <div key={index} className={st['fix-bar-item']}
                                onClick={()=>handleClick(item)}
                            >
                                <Icon name={item.icon} className={st['fix-bar-icon']}/>
                                <p className={st['fix-bar-name']}>
                                    {item.name}
                                </p>
                                <div className={st['fix-bar-child']}>
                                    <div className={st[`fix-bar-${item.className}`]}>
                                        {item.list?.map((temp, inx) => {
                                            return (
                                                <div key={inx}>
                                                    {temp.src && <img src={temp.src} alt={temp.name} />}
                                                    {temp.path ?
                                                        <Link to={`/${type}${temp.path}`}>
                                                            {temp.name}
                                                        </Link>
                                                    : temp.name}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <div className={cn(st['backToTop'], st['fix-bar-item'], {
                        [st['top-box-none']]: !showScrollTop
                    })}
                        onClick={goTop}
                    >
                        <Icon name="youce-fanhuidingbu" className={st['fix-bar-icon']}/>
                        <p className={st['fix-bar-name']}>返回顶部</p>
                    </div>
                </div>
            </div>
        </>
    )
})
